<template>
	<div class="d-flex align-items-center min-vh-100">
		<div class="container">
			<div class="row">
				<div class="col">
					<div class="card animate__animated animate__fadeIn">
						<div class="card-header bg-white text-center">ИНСТРУКЦИИ</div>
						<div class="list-group text-center">
							<div class="list-group-item">Вы отправляетесь в подземелье с целью его зачистить, а также для прокачки уровня и получения  опыта игрока.</div>
							<div class="list-group-item">Щелкайте по плиткам, чтобы открывать эти области и узнавать, что находится в соседних плитках. Вы можете увидеть, что содержится в плитках, окруженных зеленым туманом.</div>
							<div class="list-group-item">Вы можете обнаружить бандитов. Они мешают открывать смежные плитки. Заблокированные плитки отмечены красным туманом. Бандитов нужно победить, чтобы разблокировать смежные плитки.</div>
							<div class="list-group-item">щелкните на плитку с бандитом, чтобы атаковать его. Враг несет ответный удар, если выживет после атаки. У вас и у вашего врага есть небольшой шанс уклониться от атаки. Шанс зависит от бонуса уклонения. Если бандит выживет, то вы должны снова атаковать его. Убивая бандитов, вы получаете в награду то, что они украли (бонусы к здоровью, атаке или шансу уклонения). Бонус шанса уклонения можно получить только в битве с бандитами.</div>
							<div class="list-group-item">Чем больше бандитов вы оставите в живых, тем сильнее они станут. Выбирайте: можно сражаться с ними, делая их слабее, либо избегать, рискуя сделать их сильнее.</div>
							<div class="list-group-item">В некоторых комнатах лежат полезные предметы, например бонусы к здоровью или атаке. Щелкните по плитке с бонусом, чтобы немедленно его получить. Бонус к здоровью добавляет очки здоровья, а бонус к атаке повышает урон от ваших атак.</div>
							<div class="list-group-item">Желтые комнаты - это переход на следующий уровень подземелья. Пройдя уровень, вы получите опыт.</div>
							<div class="list-group-item">В любой момент вы можете закончить игровой раунд. После принудительного завершения игрового раунда, его результаты не сохраняются.</div>
							<div class="list-group-item">При переходе на новый уровень сила атаки бандитов увеличится на {{appModel.bandits_damage_nextlevel_plus}} единиц силы, их здоровье пополнится на {{appModel.bandits_health_nextlevel_plus}} единиц жизни и шанс уклонения от атаки увеличится на {{appModel.bandits_evasion_nextlevel_plus}}%.</div>
							<div class="list-group-item">При неполной зачистке уровня от бандитов, они станут сильнее на {{appModel.bandits_damage_nextlevel_plus2}} единиц силы, их здоровье пополнится дополнительно на {{appModel.bandits_health_nextlevel_plus2}} единиц жизни и шанс уклонения от атаки увеличится на {{appModel.bandits_evasion_nextlevel_plus2}}%.</div>
							<div class="list-group-item">При незачистке уровня от бандитов, они станут сильнее на {{appModel.bandits_damage_nextlevel_plus3}} единиц силы, их здоровье пополнится дополнительно на {{appModel.bandits_health_nextlevel_plus3}} единиц жизни и шанс уклонения от атаки увеличится на {{appModel.bandits_evasion_nextlevel_plus3}}%.</div>
							<div class="list-group-item">Бонус к здоровью восполняет {{appModel.booster_health_plus}} единиц(у) жизни</div>
							<div class="list-group-item">Бонус к силе атаки добавляет {{appModel.booster_damage_plus}} единиц(у) силы</div>
							<div class="list-group-item">Бонус к шансу уклонения от атаки добавляет {{appModel.booster_evasion_plus}}% шанса</div>
							<div class="list-group-item">Переход на новый уровень добавляет {{appModel.booster_exp_nextlevel_plus}} очков</div>
							<div class="list-group-item">Открытие не открытой ячейки добавляет {{appModel.booster_exp_open_plus}} очков</div>
							<div class="list-group-item">Открытие ячейки бонуса к здоровью добавляет {{appModel.booster_exp_health_plus}} очков</div>
							<div class="list-group-item">Открытие ячейки бонуса к шансу уклонения от атаки добавляет {{appModel.booster_exp_evasion_plus}} очков</div>
							<div class="list-group-item">Открытие ячейки бонуса к атаке добавляет {{appModel.booster_exp_damage_plus}} очков</div>
							<div class="list-group-item">Зачистка ячейки от бандитов добавляет 50 + (50 * уровень) очков</div>
						</div>
						<div class="card-body text-center">
							<router-link :to="{path: '/', query: {u: username}}" class="btn btn-lg btn-primary">На главную</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Инструкции | TankOn2'});
	},
	data: () => ({
		username: '',
    }),
    methods: {
		redirectToAuth(){
			const redirectUri = window.location.origin;
			const authUrl = 'https://id.bylex.su/login-out?' + new URLSearchParams({
				redirect: redirectUri,
			});
			window.location.href = authUrl;
		},
	},
	mounted(){
		if(this.$route.query.u) this.username = this.$route.query.u;
		else this.username = this.authModel.getLogin();
		
		window.scrollTo(0, 0);
	},
	beforeRouteUpdate(to, from, next){
		if(to.query.u != this.username) this.username = to.query.u || '';
		else this.username = this.authModel.getLogin();
		
		window.scrollTo(0, 0);
		next();
	},
	components: {},
}
</script>